import styled from 'styled-components'

export const ErrorMessage = styled.div<{
  $variant: 'dark' | 'light'
  $narrow?: boolean
  downloadsError?: string
}>`
  font-size: ${p => (p.$narrow ? '0.75rem' : '0.875rem')};
  color: ${p => p.theme.colors.red[4]};
  padding: ${p => (p.$narrow ? '.5rem' : '1rem')};
  border-radius: 0.6rem;
  border: 1.5px solid ${p => p.theme.colors.red[4]};
  background-color: rgba(0, 0, 0, 0.085);
  margin-bottom: ${({ downloadsError }) => (downloadsError ? '1rem' : '0')};
`
